module.exports = __webpack_public_path__ + "img/card-cbDJ.cbcaf8cc.svg";